
import React from 'react';
import { Button } from '@/components/ui/button';
import { Users, X } from 'lucide-react';
import { type FamilyMember } from './types';

interface FamilyMembersListProps {
  members: FamilyMember[];
  currentUserId?: string;
  onRemoveMember: (member: FamilyMember) => void;
}

const FamilyMembersList = ({ members, currentUserId, onRemoveMember }: FamilyMembersListProps) => {
  if (members.length === 0) {
    return (
      <div className="text-center py-4 border rounded-md">
        <p className="text-muted-foreground">No family members yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {members.map((member) => (
        <div key={member.id} className="flex items-center justify-between p-3 border rounded-md">
          <div className="flex items-center gap-3">
            <Users className="h-5 w-5 text-muted-foreground" />
            <div>
              {member.user_id === currentUserId ? (
                <span className="font-medium">You</span>
              ) : (
                <span>{member.email}</span>
              )}
              <div className="flex items-center gap-2 text-sm">
                <span className="text-muted-foreground capitalize">{member.role}</span>
                {member.status === 'pending' && (
                  <span className="bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full text-xs">
                    Pending
                  </span>
                )}
              </div>
            </div>
          </div>
          {(member.user_id !== currentUserId || member.status === 'pending') && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onRemoveMember(member)}
              className="text-destructive hover:text-destructive/90"
            >
              <X className="h-4 w-4" />
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};

export default FamilyMembersList;
